package com.klantenstop.web.data.models.dto.requests.address

import kotlinx.serialization.Serializable

@Serializable
data class ValidateCityDto(
    val city: String,
    val country: String,
    val province: String? = null
)
